import gql from 'graphql-tag'

export default ({ name, countryId }) => {
	return {
		mutation: gql`
			mutation insertSingleCampaign($campaign: conf_campaigns_insert_input!) {
				insert_conf_campaigns_one(object: $campaign) {
					id
				}
			}
		`,
		variables: {
			campaign: {
				name,
				country_id: countryId,
				active: true
			}
		}
	}
}
